﻿/* Progressive GET forms and crawlable pagination. Mobile filters apply together. */
(() => {
  if (window.kpFacetsReady || !document.querySelector('[data-kp-results]')) return;
  window.kpFacetsReady = true;
  const root = () => document.querySelector('[data-kp-results]');
  let controller, timer, sequence = 0;
  history.replaceState({ ...history.state, kpResults: true }, '', location.href);
  const formUrl = (form) => {
    const url = new URL(form.action, location.origin);
    url.search = '';
    for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
    return url.pathname + url.search;
  };
  const render = async (url, { push = true, page = false } = {}) => {
    clearTimeout(timer);
    controller?.abort();
    controller = new AbortController();
    const current = ++sequence;
    const old = root();
    if (!old) return;
    const focusId = document.activeElement?.id;
    const expanded = [...old.querySelectorAll('details[open][data-kp-facet]')].map(el => el.dataset.kpFacet);
    const drawer = old.querySelector('kp-filter-drawer');
    if (drawer && !drawer.hidden) drawer.close();
    old.setAttribute('aria-busy', 'true');
    old.classList.add('is-loading');
    try {
      const target = new URL(url, location.origin);
      target.searchParams.set('section_id', old.dataset.sectionId);
      const response = await fetch(target, { signal: controller.signal });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-kp-results]');
      if (!fresh) throw new Error('Missing results');
      if (current !== sequence) return;
      old.replaceWith(fresh);
      expanded.forEach(key => fresh.querySelectorAll('[data-kp-facet]').forEach(el => {
        if (el.dataset.kpFacet === key) el.open = true;
      }));
      if (push) history.pushState({ ...history.state, kpResults: true }, '', url);
      const focus = !page && focusId && document.getElementById(focusId);
      if (focus) focus.focus({ preventScroll: true });
      else {
        const heading = fresh.querySelector('.kp-toolbar__count, h1');
        heading?.setAttribute('tabindex', '-1');
        heading?.focus({ preventScroll: true });
      }
      if (page) fresh.querySelector('[data-kp-toolbar]')?.scrollIntoView({ block: 'start' });
    } catch (error) {
      if (error.name !== 'AbortError' && current === sequence) location.assign(url);
    } finally {
      if (current === sequence) {
        root()?.removeAttribute('aria-busy');
        root()?.classList.remove('is-loading');
      }
    }
  };
  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-kp-facets-form], [data-kp-sort-form]');
    if (!form || !root()?.contains(form) || form.closest('kp-filter-drawer')) return;
    clearTimeout(timer);
    controller?.abort(); sequence++;
    timer = setTimeout(() => { if (form.reportValidity()) render(formUrl(form)); }, event.target.type === 'number' ? 500 : 180);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-kp-facets-form], [data-kp-sort-form]');
    if (!form || !root()?.contains(form)) return;
    event.preventDefault();
    if (form.reportValidity()) render(formUrl(form));
  });
  document.addEventListener('click', (event) => {
    const apply = event.target.closest('[data-kp-filter-apply]');
    if (apply) {
      const form = apply.closest('kp-filter-drawer')?.querySelector('form');
      if (form?.reportValidity()) render(formUrl(form));
      return;
    }
    const link = event.target.closest('[data-kp-facet-link], [data-kp-pagination] a');
    if (!link || !root()?.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    render(link.href, { page: !!link.closest('[data-kp-pagination]') });
  });
  window.addEventListener('popstate', () => render(location.href, { push: false }));
})();

